import { useSnackbar } from 'notistack'
import React, { FC, useEffect, useRef, useState } from 'react'
import { MarkupPropsType, MarkupType } from '../../../api/appAPI'
import { EnqueueSnackbarType, showMessage } from '../../common/Helpers'
import MarkupUIBox from './MarkupUIBox'

interface IProps {
    markup: MarkupType

    editMarkup(id: number, markup: MarkupPropsType, enqueueSnackbar: EnqueueSnackbarType): void
}

const EditMarkup: FC<IProps> = ({ markup, editMarkup, ...props }) => {
    const idRef = useRef(markup.id)
    const [markupProps, setMarkupProps] = useState({
        name: markup.name,
        value: markup.value.toString()
    })
    const markupPropsRef = useRef(markupProps)

    const [needSave, setNeedSave] = useState(false)
    const needSaveRef = useRef(needSave)

    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        idRef.current = markup.id
        setMarkupProps({
            name: markup.name,
            value: markup.value.toString()
        })

        setNeedSave(false)

    }, [markup])

    useEffect(() => {
        markupPropsRef.current = markupProps
        needSaveRef.current = needSave
    }, [needSave, markupProps])

    useEffect(() => () => {
        if (needSaveRef.current) {
            if (window?.confirm('Save markup?')) {
                handleSaveClick()
            }
        }
    }, [markup])

    const handleNameChange = (event: React.ChangeEvent<{ value: string }>) => {
        setMarkupProps({
            ...markupProps,
            name: event.target.value.replace(/['"]/, '')
        })
        setNeedSave(true)
    }

    const handleValueChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setMarkupProps({
            ...markupProps,
            value: event.target.value as string
        })
        setNeedSave(true)
    }

    const handleSaveClick = () => {
        const name = markupPropsRef.current.name
        const value = markupPropsRef.current.value

        if (name === '') {
            showMessage(enqueueSnackbar, "Enter markup name")
            return
        }

        if (value === '') {
            showMessage(enqueueSnackbar, "Enter markup value")
            return
        }

        needSaveRef.current = false
        setNeedSave(false)

        const newMarkupProps = {
            name,
            value: parseFloat(value)
            // editable: markup.editable
        } as MarkupPropsType

        editMarkup(idRef.current, newMarkupProps, enqueueSnackbar)
    }

    return (
        <MarkupUIBox
            title='Edit Markup'
            name={{
                value: markupProps.name,
                onChange: handleNameChange
            }}
            value={{
                value: markupProps.value,
                onChange: handleValueChange
            }}

            button={{
                text: 'Save',
                onClick: handleSaveClick
            }}

            needSave={needSave}
        // editable={markup.editable === '1'}
        />
    )
}

export default EditMarkup